<div class="content">
    <div class="title">{{ sessionRow?.name }}</div>
    <div class="legend">{{ sessionRow?.comment }}</div>
    <div class="duration">
        <span class="libtag" [ngClass]="sessionRow?.libraryTag">
            {{ 'session_tag_' + sessionRow?.libraryTag | translate }}
        </span>
        <span>{{ duration | durationVerbose:'seconds' }}</span>
    </div>
</div>
<div class="adn">
    <table-histogram-chart *ngIf="sessionRow && sessionRow.adn && sessionRow.histogramData"
                           [showOnlyBar]="true"
                           [rows]="sessionRow.histogramData.rows"
                           [columns]="sessionRow.histogramData.cols"
                           [values]="sessionRow.histogramData.values">
    </table-histogram-chart>
</div>
